// extracted by mini-css-extract-plugin
export default {"component":"index-module__component--rtKI6","component--tall":"index-module__component--tall--9DQis","content":"index-module__content--BK9xR"};